const commonOutput = `Marco jurídico para la paz
https://www.tutellus.com/ciencias-sociales/derecho/marco-juridico-para-la-paz-618?affref=demo
Soluciones para movilidad urbana en grandes ciudades
https://www.tutellus.com/ciencias-aplicadas/ingenierias/soluciones-para-movilidad-urbana-en-grandes-ciudades-619?affref=demo
Qué es el Crowdsourcing y mapeo de información
https://www.tutellus.com/ciencias-aplicadas/informatica/aprender-sobre-crowdsourcing-y-mapeo-de-informacion-625?affref=demo
Emprendimiento en el Cloud Incubator Hub
https://www.tutellus.com/ciencias-sociales/marketing/emprendimiento-en-el-cloud-incubator-hub-642?affref=demo`

export const apiExamples = [
  {
    name: 'JavaScript',
    language: 'javascript',
    code: `$.ajax({
    url: 'https://affiliate.tutellus.com/api/v1/courses',
    type: 'GET',
    dataType: 'json',
    headers: {
        'x-access-token': '<your access token>'
    },
    success: function(data) {
        $.each(data, function(count) {
            console.log(data[count].name);
            console.log(data[count].url);
        });
    },
});`,
    output: commonOutput
  },
  {
    name: 'Node.js',
    language: 'javascript',
    code: `var http = require('https');
var options = {
    host: 'affiliate.tutellus.com',
    path: '/api/v1/courses',
    headers: {
        'x-access-token': '<your access token>',
    },
};
function callback(response) {
    var str = '';
    response.on('data', function (chunk) {
        str += chunk;
    });
    response.on('end', function () {
        var courses = JSON.parse(str);
        for (var i = 0; i < courses.length; i++) {
            console.log(courses[i].name);
            console.log(courses[i].url);
        }
    });
}
http.request(options, callback).end();`,
    output: commonOutput
  },
  {
    name: 'PHP',
    language: 'php',
    code: `$opts = array('header'=>"x-access-token: <your access token>");
$context = stream_context_create($opts);
$resp = file_get_contents('https://affiliate.tutellus.com/api/v1/courses/', false, $context);
$json_response = json_depre($resp, true);
foreach ($json_response as $course) {
  echo $course["name"], "<br>";
  echo $course["url"], "<br>";
}`,
    output: commonOutput
  },
  {
    name: 'Python',
    language: 'python',
    code: `import json
import urllib2
req = urllib2.Request('http://affiliate.tutellus.com/api/v1/courses');
req.add_header('x-access-token', '<your access token>')
response = urllib2.urlopen(req)
json_response = json.loads(response.read())
for course in json_response:
    print course['name']
    print course['url']`,
    output: commonOutput
  },
  {
    name: 'Ruby',
    language: 'ruby',
    code: `require 'HTTParty'
res = HTTParty.get(
    'http://affiliate.tutellus.com/api/v1/courses',
    :headers => headers = {
        'x-access-token' => '<your access token>'
    })
courses = JSON.parse(res.body)
courses.each do |course|
    puts course['name']
    puts course['url']
end`,
    output: commonOutput
  }
]



// WEBPACK FOOTER //
// ./src/pages/api_examples.js